import { render, staticRenderFns } from "./MdRichEdit.vue?vue&type=template&id=5a2a6268&scoped=true&"
import script from "./MdRichEdit.vue?vue&type=script&lang=js&"
export * from "./MdRichEdit.vue?vue&type=script&lang=js&"
import style0 from "./MdRichEdit.vue?vue&type=style&index=0&id=5a2a6268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2a6268",
  null
  
)

export default component.exports